<template>
    <div class="e_handle_content page_update_tmember">
        <div class="topOperation">
            <div class="top-left">
                <ShowNavHead />
            </div>
        </div>
        <div class="main-con">
            <div class="crumbs">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>产品</el-breadcrumb-item>
                <el-breadcrumb-item>灵活用工</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/teamMembers' }">施工队员列表</el-breadcrumb-item>
                <el-breadcrumb-item>{{pageTitle}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="e_handle_box">
                <p class="r_edit_title">基础信息</p>
                <div class="e_handle_form" v-loading="formLoading">
                    <el-form :inline="true" :rules="basicRules" ref="enterResumeForm" :model="basicQuery" class="e_form_box" label-width="166px">
                        <el-form-item label="施工队:" prop="GdteamId">
                            <el-select :disabled="isEdit" v-model="basicQuery.GdteamId" placeholder="" filterable size="small" @change="teamHandle" clearable>
                                <el-option v-for="(item,i) in teamList" :key="i+'d'" :label="item.StrConstrteamName" :value="item.GdteamId"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="人员编号:" prop="StrPersonNumOther" v-if="!isNull(basicQuery.GdteamId)">
                            <div class="c_form_box">
                                <span class="c_edit_txt">{{strConstrteamCode}}</span>
                                <el-input :disabled="isEdit" @blur="checkPresentHandle" v-model="basicQuery.StrPersonNumOther" size="small" clearable placeholder="请输入01-99之间的数字,如01"></el-input>
                            </div>
                        </el-form-item> -->
                        <el-form-item label="人员类别:" prop="StrDutie">
                            <el-select v-model="basicQuery.StrDutie" placeholder="" size="small" >
                                <el-option label="法人" value="法人"></el-option>
                                <el-option label="施工负责人" value="施工负责人"></el-option>
                                <el-option label="信息员" value="信息员"></el-option>
                                <el-option label="施工队长" value="施工队长"></el-option>
                                <el-option label="施工队员" value="施工队员"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="是否参与实际施工:" prop="StrIsActconstr">
                            <el-select v-model="basicQuery.StrIsActconstr" placeholder="" size="small" >
                                <el-option label="是" value="是"></el-option>
                                <el-option label="否" value="否"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="姓名:" prop="StrPerName">
                            <el-input v-model="basicQuery.StrPerName" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号码:" prop="StrIdcard">
                            <el-input v-model="basicQuery.StrIdcard" size="small" ref="input" clearable @input="idcardHandle"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证有效截止期:" prop="StrIdcDate">
                            <el-date-picker size="small" value-format="yyyy-MM-dd"
                            v-model="basicQuery.StrIdcDate"
                            type="date"
                            placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="联系方式:" prop="StrMobile">
                            <el-input v-model="basicQuery.StrMobile" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="服务状态:" prop="StrPerStatus">
                            <el-select v-model="basicQuery.StrPerStatus" placeholder="" size="small" filterable>
                                <el-option v-for="(item,i) in serviceList" :key="i+'d'" :label="item.Basname" :value="item.Basname"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="退出日期:" prop="DtexitDate" v-if="basicQuery.StrPerStatus == '退出'">
                            <el-date-picker size="small" value-format="yyyy-MM-dd"
                            v-model="basicQuery.DtexitDate"
                            type="date"
                            placeholder="">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="上岗证编号:" prop="StrjoblicenNum" v-if="isIdcardTrue&&!isNull(basicQuery.GdteamId)">
                            <div class="c_form_box">
                                <span>{{basicQuery.StrjoblicenNum}}</span>
                                <!-- <el-input v-model="basicQuery.StrjoblicenNum" size="small" clearable placeholder="请填写身份证后六位"></el-input> -->
                            </div>
                        </el-form-item>
                        <el-form-item label="上岗证有效截止期:" prop="StrjobCertDate" :class="basicQuery.StrIsActconstr=='是'?'c_note_show':''">
                            <el-date-picker size="small" value-format="yyyy-MM-dd"
                            v-model="basicQuery.StrjobCertDate"
                            type="date"
                            placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="上岗证注销次数:" prop="StrjobCertoffNum" :class="basicQuery.StrIsActconstr=='是'?'c_note_show':''">
                            <el-input v-model="basicQuery.StrjobCertoffNum" size="small" min="0" type="number" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="电工证编号:" prop="StrElecertNum" v-if="isIdcardTrue&&!isNull(basicQuery.StrIdcard)">
                            <div class="c_form_box">
                                <!-- <span>T</span> -->
                                <el-input v-model="basicQuery.StrElecertNum" size="small" clearable placeholder=""></el-input>
                            </div>
                            <!-- <span>{{basicQuery.StrElecertNum}}</span> -->
                        </el-form-item>
                        <el-form-item label="电工证类型:" prop="StrElecertType" :class="basicQuery.StrIsActconstr=='是'?'c_note_show':''">
                            <el-select v-model="basicQuery.StrElecertType" placeholder="" size="small" >
                                <el-option label="高压电工证" value="高压电工证"></el-option>
                                <el-option label="低压电工证" value="低压电工证"></el-option>
                                <el-option label="其他" value="其他"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="电工证有效截止期:" prop="StreffectDate" :class="basicQuery.StrIsActconstr=='是'?'c_note_show':''">
                            <el-date-picker size="small" value-format="yyyy-MM-dd"
                            v-model="basicQuery.StreffectDate"
                            type="date"
                            placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="意外险保单号:" prop="StrAccinsupolinum" :class="basicQuery.StrIsActconstr=='是'?'c_note_show':''">
                            <el-input v-model="basicQuery.StrAccinsupolinum" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="意外险保单有效截止期:" prop="StrAccinsupoliDate" :class="basicQuery.StrIsActconstr=='是'?'c_note_show':''">
                            <el-date-picker size="small" value-format="yyyy-MM-dd"
                            v-model="basicQuery.StrAccinsupoliDate"
                            type="date"
                            placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="签入日期:" prop="DtBringDate">
                            <el-date-picker size="small" value-format="yyyy-MM-dd"
                            v-model="basicQuery.DtBringDate"
                            type="date"
                            placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="备注:" prop="StrRemark">
                            <el-input v-model="basicQuery.StrRemark" type="textarea" size="small" clearable></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="f_upload_box">
                        <p class="r_edit_title"><span v-if="basicQuery.StrIsActconstr == '是'" class="note_icon">*</span>
                        1寸照</p>
                        <div class="f_upload_list">
                            <!-- <div class="f_upload_left">营业执照:</div> -->
                            <!--  :file-list="fileSupList01" -->
                            <div class="f_upload_right">
                                <p class="u_txt">注：仅限白底/蓝底</p>
                                <el-upload  :auto-upload="false" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG,.webp"
                                action="#" :multiple="false" :limit="1" :file-list="fileSupList01"
                                :on-change="(file,fileList)=>{return handleUpdateChange(file,fileSupList01,'1')}"
                                list-type="picture-card"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'1',fileSupList01)}">
                                <i class="el-icon-plus"></i>
                                </el-upload>
                            </div>
                        </div>
                        <p class="r_edit_title"><span v-if="basicQuery.StrIsActconstr == '是'" class="note_icon">*</span>意外保险保单</p>
                        <div class="f_upload_list">
                            <!-- <div class="f_upload_left">法人委托授权书:</div>  :file-list="fileSupList02"-->
                            <div class="f_upload_right">
                                <p class="u_txt">注：保额大于50万（上传扫描件或照片）</p>
                                <el-upload action="#" list-type="picture-card" :auto-upload="false" :file-list="fileSupList02"
                                :on-change="(file)=>{return handleUpdateChange(file,fileSupList02,'2')}" ref="upload">
                                    <i slot="default" class="el-icon-plus"></i>
                                    <div slot="file" slot-scope="{file}" class="up_box">
                                        <img v-if="updataIf(file)" class="file_img" src="./../../assets/images/file.png" alt="">
                                        <img v-else class="el-upload-list__item-thumbnail" :src="tablePath+file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span v-if="updataIf(file)" class="el-upload-list__item-delete" @click="handleDownload(file)">
                                                <i class="el-icon-download"></i>
                                            </span>
                                            <span v-if="!updataIf(file)" class="el-upload-list__item-preview" @click="handlePictureCardPreview01(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span v-if="!disabled01" class="el-upload-list__item-delete" @click="handleRemove(file,'','2',fileSupList02)">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </el-upload>
                            </div>
                        </div>
                        <p class="r_edit_title"><span class="note_icon">*</span>身份证照片</p>
                        <div class="f_upload_list">
                            <!-- <div class="f_upload_left">工程车照片:</div>  :file-list="fileSupList03"-->
                            <div class="f_upload_right">
                                <p class="u_txt">注：上传正、反面</p>
                                <el-upload :auto-upload="false" accept=".jpg,.jpeg,.png,.pdf,.PDF,.JPG,.JPEG,.PNG,.webp" :file-list="fileSupList03"
                                :on-change="(file)=>{return handleUpdateChange(file,fileSupList03,'3')}"
                                action="#"
                                list-type="picture-card"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'3',fileSupList03)}">
                                <i class="el-icon-plus"></i>
                                </el-upload>
                            </div>
                        </div>
                        <p class="r_edit_title"><span v-if="basicQuery.StrIsActconstr == '是'" class="note_icon">*</span>电工证照片</p>
                        <div class="f_upload_list">
                            <!-- <div class="f_upload_left">仓库照片:</div>  :file-list="fileSupList04"-->
                            <div class="f_upload_right">
                                <p class="u_txt">注：上传正、反面</p>
                                <el-upload :auto-upload="false" accept=".jpg,.jpeg,.png,.pdf,.PDF,.JPG,.JPEG,.PNG,.webp" :file-list="fileSupList04"
                                :on-change="(file)=>{return handleUpdateChange(file,fileSupList04,'4')}"
                                action="#"
                                list-type="picture-card"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'4',fileSupList04)}">
                                <i class="el-icon-plus"></i>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="e_btns_box">
                    <el-button size="small" @click="backHandle">取消</el-button>
                    <el-button type="primary" :loading="btnLoading" @click="saveHandle" size="small">保存</el-button>
                </div> -->
            </div>
        </div>
        <div class="e_btns_box">
            <div class="e_btns_content">
                <el-button @click="backHandle">取消</el-button>
                <el-button type="primary" :loading="btnLoading" @click="saveHandle">保存</el-button>
            </div>
        </div>
        <!-- 图片预览弹框 -->
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible01">
            <img width="100%" :src="tablePath+dialogImageUrl01" alt="">
        </el-dialog>
    </div>
</template>
  
<script>
import xz from "./../../common";
import moment from 'moment'
export default {
    data() {
        var validatePhone = (rule, value, callback) => {
            const phoneReg = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
            // console.log('validatePhone',value)
            if (value.length == 11 && phoneReg.test(value)) {
                //校验通过
                callback()
            } else {
                callback(new Error('请输入正确的手机号'))
            }
        }
        var validatecard = (rule, value, callback) => {
            // console.log(44,value)
            if (value.length != 18) {
                callback(new Error('身份证号码格式不正确'));
                this.isIdcardTrue = false
            } else {
                let that = this
                let idcode = value;
                let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2,];
                let check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
                let code = idcode + "";
                let last = idcode[17].toUpperCase(); //最后一个
                let seventeen = code.substring(0, 17);
                // ISO 7064:1983.MOD 11-2
                // 判断最后一位校验码是否正确
                let arr = seventeen.split("");
                let len = arr.length;
                let num = 0;
                for (let i = 0; i < len; i++) {
                    num = num + arr[i] * weight_factor[i];
                }
                // 获取余数
                var resisue = num % 11;
                var last_no = check_code[resisue];
                // 格式的正则
                // 正则思路
                var idcard_patter = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
                // 判断格式是否正确
                var format = idcard_patter.test(idcode);
                if (last === last_no && format == true) {
                    that.isIdcardTrue = true
                    this.basicQuery.StrElecertNum = 'T'+this.basicQuery.StrIdcard
                    if(!that.isNull(that.basicQuery.GdteamId)){
                        let lastSix = that.basicQuery.StrIdcard.substring(12,18)
                        that.basicQuery.StrjoblicenNum = that.strConstrteamCode + lastSix//上岗证编号---施工队编号+该队员身份证号码后六位
                    }
                    callback()
                } else {
                    this.basicQuery.StrElecertNum = ''
                    this.basicQuery.StrjoblicenNum = ''
                    callback(new Error('身份证号码格式不正确'));
                }
            }
        };
        return {
            timer:null,
            elecertNum:'',//电工证编号
            pageTitle:'新增施工队员',
            // 身份证是否正确
            isIdcardTrue:false,
            fileSupList01:[],
            fileSupList02:[],
            fileSupList03:[],
            fileSupList04:[],
            disabled01:false,
            btnLoading:false,
            formLoading:false,
            // 默认头像
            defaultPic: require(("./../../assets/images/psn.png")),
            // 规则
            basicRules: {
                GdteamId: [
                    { required: true, message: '请选择施工队', trigger: 'change' }
                ],
                // StrPersonNumOther: [
                //     { required: true, message: '请输入人员编号', trigger: 'blur' }
                // ],
                StrPerName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                StrPerStatus: [
                    { required: true, message: '请选择服务状态', trigger: 'change' }
                ],
                StrIdcDate: [
                    { required: true, message: '请选择身份证有效截止期', trigger: 'change' }
                ],
                StrIdcard: [
                    { required: true, message: '请输入身份证号码', trigger: 'blur' },
                    { message: '请输入正确的身份证号码', validator: validatecard, trigger: ['blur','change'] }
                ],
                StrMobile: [
                    { required: true, message: '请输入联系方式', trigger: 'blur' },
                    { validator: validatePhone, trigger: ['blur'] }
                ],
                StrDutie: [
                    { required: true, message: '请选择人员类别', trigger: 'change' }
                ],
                DtBringDate: [
                    { required: true, message: '请选择签入日期', trigger: 'change' }
                ]
            },
            isDetail: true,
            isEdit: false,
            // 施工队列表
            teamList:[],
            // 新增施工队参数
            basicQuery:{
                GdteamperId:'', //人员id
                StrPersonNum:'', //人员编号
                StrPersonNumOther:'',
                GdteamId:'', //施工队编号
                StrPerName:'', //姓名
                StrPerStatus:'', //服务状态
                StrDutie:'', //人员类别
                StrIsActconstr:'', //是否参与实际施工
                StrIdcard:'', //身份证号码
                StrIdcDate:'', //身份证有效期
                StrMobile:'', //联系方式
                StrjoblicenNum:'', //上岗证编号
                StrjobCertDate:'', //上岗证有效期
                StrjobCertoffNum:'', //上岗证注销次数
                StrElecertNum:'', //电工证编号
                StrElecertType:'', //电工证类型
                StreffectDate:'', //电工证有效期
                StrAccinsupolinum:'', //意外险保单号
                StrAccinsupoliDate:'', //意外险保单有效期
                StrRemark:'', //备注
                DtexitDate:'',//退出时间
                DtBringDate:'', //签入日期
                Strsettlement:'', //是否负责结算
                StrBankCardNum:'', //银行卡号码
                StrBankCardName:'', //银行名称
                StrresponNum:'', //第三方责任险保单号（平台投保
                Strrespondeadline:'' //第三方责任险保单有效截止日期
            },
            tablePath: this.$store.state.EMP.docPath,
            isLongCheck: false,
            activeName:'',
            // 1寸照
            imageUrl:'',
            // 预览图
            dialogImageUrl:'',
            dialogVisible:false,
            dialogImageUrl01:'',
            dialogVisible01:false,
            // 施工队列表参数
            teamQuery:{
                strConstrteamName:'',// 施工队名称
                strSerStatus:'',// 服务状态 正常/退出
                strExamStatus:'',// 通过/不通过
                strArea:'',//区域
                strCityCompany:'',//城市公司
                currpage:1,
                perpage:100000
            },
            // 施工队编号
            strConstrteamCode:'',
            // 服务状态列表参数
            serviceQuery:{
                StrPerStatus:'StrPerStatus'
            },
            serviceList:[],
            checkQuery:{
                StrPersonNum:'',
                GdteamperId:''
            },
            provinces:[],
            cityList:[],
            // 获取所有市
            allCityQuery:{
                strgrade:'4'
            }
        }
    },
    created() {
        this.getTeamList()
        this.getServiceList()
        if(!this.isNull(this.$route.query.id)){
            this.isEdit = true
            this.pageTitle = '编辑施工队员'
            this.basicQuery.GdteamperId = this.$route.query.id
            // 获取详情
            this.getDetailData(this.basicQuery.GdteamperId)
        }else{
            this.isEdit = false
            this.pageTitle = '新增施工队员'
        }
        if(!this.isNull(this.$route.query.GdteamId)){//从施工队跳转过来
            this.basicQuery.GdteamId = this.$route.query.GdteamId
        }
        this.getAreaTree(this.allCityQuery,'city')
        // this.processQuery.Jobid = this.$route.params.Jobid
    },
    methods:{
        // 保存
        saveHandle(){
            let allFileList = [];
            // console.log('yy',this.fileSupList01,this.fileSupList02,this.fileSupList03,this.fileSupList04)
            this.$refs['enterResumeForm'].validate((valid) => {
                if (valid) {
                    // this.basicQuery.StrPersonNum = this.strConstrteamCode + this.basicQuery.StrPersonNumOther
                    if((this.basicQuery.StrIsActconstr == '是')&&this.isNull(this.basicQuery.StrjobCertDate)){
                        this.$message({ type: 'warning', message: '请选择上岗证有效截止期' })
                        return false
                    }
                    if((this.basicQuery.StrIsActconstr == '是')&&this.isNull(this.basicQuery.StrjobCertoffNum)){
                        this.$message({ type: 'warning', message: '请输入上岗证注销次数' })
                        return false
                    }
                    if((this.basicQuery.StrIsActconstr == '是')&&this.isNull(this.basicQuery.StrElecertType)){
                        this.$message({ type: 'warning', message: '请选择电工证类型' })
                        return false
                    }
                    if((this.basicQuery.StrIsActconstr == '是')&&this.isNull(this.basicQuery.StreffectDate)){
                        this.$message({ type: 'warning', message: '请选择电工证有效截止期' })
                        return false
                    }
                    if((this.basicQuery.StrIsActconstr == '是')&&this.isNull(this.basicQuery.StrAccinsupolinum)){
                        this.$message({ type: 'warning', message: '请输入意外险保单号' })
                        return false
                    }
                    if((this.basicQuery.StrIsActconstr == '是')&&this.isNull(this.basicQuery.StrAccinsupoliDate)){
                        this.$message({ type: 'warning', message: '请选择意外险保单有效截止期' })
                        return false
                    }
                    if((this.basicQuery.StrIsActconstr == '是')&&this.isNull(this.fileSupList01)){
                        this.$message({ type: 'warning', message: '请上传1寸照' })
                        return false
                    }
                    if((this.basicQuery.StrIsActconstr == '是')&&this.isNull(this.fileSupList02)){
                        this.$message({ type: 'warning', message: '请上传意外保险保单' })
                        return false
                    }
                    if(this.isNull(this.fileSupList03)){
                        this.$message({ type: 'warning', message: '请上传身份证正反照片' })
                        return false
                    }
                    if(!this.isNull(this.fileSupList03)&&this.fileSupList03.length<2){
                        this.$message({ type: 'warning', message: '请上传身份证正反照片' })
                        return false
                    }
                    if((this.basicQuery.StrIsActconstr == '是')&&this.isNull(this.fileSupList04)){
                        this.$message({ type: 'warning', message: '请上传电工证正反照片' })
                        return false
                    }
                    if((this.basicQuery.StrIsActconstr == '是')&&!this.isNull(this.fileSupList04)&&(this.fileSupList04.length<2)){
                        this.$message({ type: 'warning', message: '请上传电工证正反照片' })
                        return false
                    }
                    this.btnLoading = true
                    if(!this.isNull(this.fileSupList01)){
                        for (let i = 0; i < this.fileSupList01.length; i++) {
                            let element1 = this.fileSupList01[i];
                            if(element1.url.indexOf(this.tablePath)>-1){
                                element1.url = element1.url.split(this.tablePath)[1]
                            }
                        }
                    }
                    if(!this.isNull(this.fileSupList03)){
                        for (let j = 0; j < this.fileSupList03.length; j++) {
                            let element2 = this.fileSupList03[j];
                            if(element2.url.indexOf(this.tablePath)>-1){
                                element2.url = element2.url.split(this.tablePath)[1]
                            }
                        }
                    }
                    if(!this.isNull(this.fileSupList04)){
                        for (let m = 0; m < this.fileSupList04.length; m++) {
                            let element3 = this.fileSupList04[m];
                            if(element3.url.indexOf(this.tablePath)>-1){
                                element3.url = element3.url.split(this.tablePath)[1]
                            }
                        }
                    }
                    allFileList = this.fileSupList01.concat(this.fileSupList02, this.fileSupList03, this.fileSupList04)
                    // 去重
                    allFileList = allFileList.filter(function (item, index, self) {
                        return self.indexOf(el => el.url == item.url) == -1;
                    });
                    // console.log('saveEnterHandle', this.basicQuery,allFileList)
                    xz.saveConstrTeamPerinfo(this.basicQuery,allFileList).then(res => {
                        // console.log('saveEnterHandle', res)
                        if (res.status == 'ok') {
                            this.$message({ type: 'success', message: '操作成功' })
                            this.$router.push(
                                { path: '/teamMembers'}
                            )
                        }else{
                            this.$message({ type: 'error', message: res.msg })
                        }
                        this.btnLoading = false
                    })
                } else {
                    return false;
                }
            })
        },
        idcardHandle(val){
            console.log(2222,val)
            if(this.isNull(val)){
                this.isIdcardTrue = false
                this.basicQuery.StrjoblicenNum = ''
                this.basicQuery.StrElecertNum = ''
            }else{
                // this.$refs.input.focus();
                if(!this.isNull(this.basicQuery.GdteamId)&&this.basicQuery.StrIdcard.length == 18){
                    this.basicQuery.StrElecertNum = 'T'+this.basicQuery.StrIdcard
                    let lastSix = this.basicQuery.StrIdcard.substring(12,18)
                    this.basicQuery.StrjoblicenNum = this.strConstrteamCode + lastSix//上岗证编号---施工队编号+该队员身份证号码后六位
                }
            }
        },
        // 获取省市列表
        getAreaTree(data,type){
            xz.getAreaTree(data).then(res => {
                // console.log('entPicFile', res)
                if (res.status == 'ok') {
                    if(type == 'city'){
                        this.cityList = res.msg.parent
                    }
                } else {
                    if(type == 'city'){
                        this.cityList = []
                    }
                }
            })
        },
        // 判断编号是否存在
        checkPresentHandle(){
            this.checkQuery.StrPersonNum = this.basicQuery.StrPersonNum
            this.checkQuery.GdteamperId = this.basicQuery.GdteamperId
            xz.getIsUsedPersonCode(this.checkQuery).then(res => {
                // console.log('eee', res)
                if (res.status == 'error') {
                    this.$message({ type: 'warning', message: res.msg })
                    this.basicQuery.StrPersonNum = ''
                    return
                }
            })
        },
        // 获取详情
        getDetailData(id){
            xz.getConstrTeamPerDetail({GdteamperId:id}).then(res => {
                // console.log('www', res)
                if (res.status == 'ok') {
                    let str1 = res.msg.r.StrPersonNum
                    this.strConstrteamCode = res.msg.StrConstrteamCode
                    this.basicQuery = {
                        GdteamperId:res.msg.r.GdteamperId, //人员id
                        StrPersonNum:res.msg.r.StrPersonNum, //人员编号
                        StrPersonNumOther:str1.substring(str1.length-2,str1.length),
                        GdteamId:res.msg.r.GdteamId, //施工队编号
                        StrPerName:res.msg.r.StrPerName, //姓名
                        StrPerStatus:res.msg.r.StrPerStatus, //服务状态
                        StrDutie:res.msg.r.StrDutie, //人员类别
                        StrIsActconstr:res.msg.r.StrIsActconstr, //是否参与实际施工
                        StrIdcard:res.msg.r.StrIdcard, //身份证号码
                        StrIdcDate:res.msg.r.StrIdcDate, //身份证有效期
                        StrMobile:res.msg.r.StrMobile, //联系方式
                        StrjoblicenNum:res.msg.r.StrjoblicenNum, //上岗证编号
                        StrjobCertDate:res.msg.r.StrjobCertDate, //上岗证有效期
                        StrjobCertoffNum:res.msg.r.StrjobCertoffNum, //上岗证注销次数
                        StrElecertNum:res.msg.r.StrElecertNum, //电工证编号
                        StrElecertType:res.msg.r.StrElecertType, //电工证类型
                        StreffectDate:res.msg.r.StreffectDate, //电工证有效期
                        StrAccinsupolinum:res.msg.r.StrAccinsupolinum, //意外险保单号
                        StrAccinsupoliDate:res.msg.r.StrAccinsupoliDate, //意外险保单有效期
                        StrRemark:res.msg.r.StrRemark, //备注
                        DtexitDate:res.msg.r.DtexitDate,//退出时间
                        DtBringDate:res.msg.r.DtBringDate, //签入日期
                        Strsettlement:res.msg.r.Strsettlement, //是否负责结算
                        StrBankCardNum:res.msg.r.StrBankCardNum, //银行卡号码
                        StrBankCardName:res.msg.r.StrBankCardName, //银行名称
                        StrresponNum:res.msg.r.StrresponNum, //第三方责任险保单号（平台投保
                        Strrespondeadline:res.msg.r.Strrespondeadline //第三方责任险保单有效截止日期
                    }
                    if(!this.isNull(res.msgfile1)){
                        for (let i = 0; i < res.msgfile1.length; i++) {
                            let element1 = res.msgfile1[i];
                            this.fileSupList01.push({
                                name: element1.StrFile,
                                url: this.tablePath+element1.StrFileUrl,
                                GdfileId:element1.GdfileId, //文件id
                                GdteamperId:element1.GdteamperId, //队员id
                                StrFile:element1.StrFile, //文件名称
                                StrFileUrl: element1.StrFileUrl, //文件路径
                                StrFileType:element1.StrFileType, //种类 1营业执照 2法人委托授权书（强制）3工程车照片（强制）4仓库照片（强制）5 其他资质1（不强制）6图片上传渠道（不强制）
                                StrUrlType:element1.StrUrlType, //图片或者文档
                                StrFileContent:element1.StrFileContent, //文件内容
                                StrRemark:element1.StrRemark, //备注
                                DtStartDate:element1.DtStartDate, //开始时间
                                DtEndDate:element1.DtEndDate //结束
                            })
                        }
                    }
                    if(!this.isNull(res.msgfile2)){
                        for (let j = 0; j < res.msgfile2.length; j++) {
                            let element2 = res.msgfile2[j];
                            this.fileSupList02.push({
                                name: element2.StrFile,
                                url: element2.StrFileUrl,
                                GdfileId:element2.GdfileId, //文件id
                                GdteamperId:element2.GdteamperId, //队员id
                                StrFile:element2.StrFile, //文件名称
                                StrFileUrl: element2.StrFileUrl, //文件路径
                                StrFileType:element2.StrFileType, //种类 1营业执照 2法人委托授权书（强制）3工程车照片（强制）4仓库照片（强制）5 其他资质1（不强制）6图片上传渠道（不强制）
                                StrUrlType:element2.StrUrlType, //图片或者文档
                                StrFileContent:element2.StrFileContent, //文件内容
                                StrRemark:element2.StrRemark, //备注
                                DtStartDate:element2.DtStartDate, //开始时间
                                DtEndDate:element2.DtEndDate //结束
                            })
                        }
                    }
                    if(!this.isNull(res.msgfile3)){
                        for (let k = 0; k < res.msgfile3.length; k++) {
                            let element3 = res.msgfile3[k];
                            this.fileSupList03.push({
                                name: element3.StrFile,
                                url: this.tablePath+element3.StrFileUrl,
                                GdfileId:element3.GdfileId, //文件id
                                GdteamperId:element3.GdteamperId, //队员id
                                StrFile:element3.StrFile, //文件名称
                                StrFileUrl: element3.StrFileUrl, //文件路径
                                StrFileType:element3.StrFileType, //种类 1营业执照 2法人委托授权书（强制）3工程车照片（强制）4仓库照片（强制）5 其他资质1（不强制）6图片上传渠道（不强制）
                                StrUrlType:element3.StrUrlType, //图片或者文档
                                StrFileContent:element3.StrFileContent, //文件内容
                                StrRemark:element3.StrRemark, //备注
                                DtStartDate:element3.DtStartDate, //开始时间
                                DtEndDate:element3.DtEndDate //结束
                            })
                        }
                    }
                    if(!this.isNull(res.msgfile4)){
                        for (let l = 0; l < res.msgfile4.length; l++) {
                            let element4 = res.msgfile4[l];
                            this.fileSupList04.push({
                                name: element4.StrFile,
                                url: this.tablePath+element4.StrFileUrl,
                                GdfileId:element4.GdfileId, //文件id
                                GdteamperId:element4.GdteamperId, //队员id
                                StrFile:element4.StrFile, //文件名称
                                StrFileUrl: element4.StrFileUrl, //文件路径
                                StrFileType:element4.StrFileType, //种类 1营业执照 2法人委托授权书（强制）3工程车照片（强制）4仓库照片（强制）5 其他资质1（不强制）6图片上传渠道（不强制）
                                StrUrlType:element4.StrUrlType, //图片或者文档
                                StrFileContent:element4.StrFileContent, //文件内容
                                StrRemark:element4.StrRemark, //备注
                                DtStartDate:element4.DtStartDate, //开始时间
                                DtEndDate:element4.DtEndDate //结束
                            })
                        }
                    }
                }else{
                    this.$message({ type: 'error', message: res.msg })
                }
            })
        },
        // 选择施工队
        teamHandle(val){
            let that = this
            if(!this.isNull(val)){
                let obj = {};
                obj = this.teamList.find((item)=>{
                    return item.GdteamId === val;
                });
                this.strConstrteamCode = obj.StrConstrteamCode
                if(that.isIdcardTrue){
                    let lastSix = that.basicQuery.StrIdcard.substring(12,18)
                    that.basicQuery.StrjoblicenNum = that.strConstrteamCode + lastSix
                }
            }else{
                this.strConstrteamCode = ''
                this.basicQuery.GdteamId = ''
            }
            // console.log('11',obj)
        },
        // 下载附件
        handleDownload(file) {
            console.log(file);
            let d = file.url
            d = d.replace("\"","").replace("\"","")
            let path = this.tablePath + d
            const aTag = document.createElement('a')
            aTag.href = path
            aTag.click()
        },
        // 上传附件
        handleUpdateChange(file, dataArr, type){
            let formData = new FormData()
            formData.append("action", 'save')
            formData.append("pagename", 'bdocinf')
            formData.append("userid", Cookies.get("userid-b"))
            formData.append("entid", Cookies.get("userid-b"))
            formData.append("entPicFile", file.raw, file.name)
            // console.log('entPicFile', file)
            xz.uploadCert(formData).then(res => {
                // console.log('entPicFile', res)
                if (res) {
                    if(type == '1'){
                        this.imageUrl = res
                        dataArr = [{
                            name: file.name,
                            url: this.tablePath+res,
                            uid: file.uid,
                            GdfileId:'', //文件id
                            GdteamperId:'', //队员id
                            StrFile:file.name, //文件名称
                            StrFileUrl: res, //文件路径
                            StrFileType:type, //种类 1-1寸照 2意外保险保单（强制）3身份证照片（强制）4电工证照片（强制）
                            StrUrlType:file.raw.type, //图片或者文档
                            StrFileContent:'', //文件内容
                            StrRemark:'', //备注
                            DtStartDate:'', //开始时间
                            DtEndDate:'' //结束
                        }]
                        this.fileSupList01 = dataArr
                    }else if(type == '3'||type == '4'){
                        dataArr.push({
                            name: file.name,
                            url: this.tablePath+res,
                            uid: file.uid,
                            GdfileId:'', //文件id
                            GdteamperId:'', //队员id
                            StrFile:file.name, //文件名称
                            StrFileUrl: res, //文件路径
                            StrFileType:type, //种类 1-1寸照 2意外保险保单（强制）3身份证照片（强制）4电工证照片（强制）
                            StrUrlType:file.raw.type, //图片或者文档
                            StrFileContent:'', //文件内容
                            StrRemark:'', //备注
                            DtStartDate:'', //开始时间
                            DtEndDate:'' //结束
                        })
                        if(type == 3){
                            this.fileSupList03 = dataArr
                        }
                        if(type == 4){
                            this.fileSupList04 = dataArr
                        }
                    }else{
                        dataArr.push({
                            name: file.name,
                            url: res,
                            uid: file.uid,
                            GdfileId:'', //文件id
                            GdteamperId:'', //队员id
                            StrFile:file.name, //文件名称
                            StrFileUrl: res, //文件路径
                            StrFileType:type, //种类 1-1寸照 2意外保险保单（强制）3身份证照片（强制）4电工证照片（强制）
                            StrUrlType:file.raw.type, //图片或者文档
                            StrFileContent:'', //文件内容
                            StrRemark:'', //备注
                            DtStartDate:'', //开始时间
                            DtEndDate:'' //结束
                        })
                    }
                } else {
                    this.$message('文件上传失败,请稍后再试')
                }
            })
        },
        // 删除照片
        handleRemove(file,fileList,type,dataArr) {
            // console.log('handleRemove01',file,fileList);
            if(type == '2'){
                let arr = this.$refs.upload.uploadFiles
                let index = arr.indexOf(file)
                arr.splice(index, 1)
            }else{
                // console.log('gg',fileList)
                // let m = fileList.findIndex(item => {
                //     if (item.uid == file.uid) {
                //         return true
                //     }
                // })
                // fileList.splice(m, 1)
            }
            // console.log('index',index,arr)
            let j = dataArr.findIndex(item => {
                if (item.url == file.url) {
                    return true
                }
            })
            dataArr.splice(j, 1)
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handlePictureCardPreview01(file) {
            this.dialogImageUrl01 = file.url;
            this.dialogVisible01 = true;
        },
        // 获取服务状态列表
        getServiceList(){
            xz.getbaseBaList(this.serviceQuery.StrPerStatus).then(res => {
                // console.log('getServiceList', res)
                if (res.status == 'ok') {
                    this.serviceList = res.msg
                } else {
                    this.serviceList = []
                }
            })
        },
        // 获取施工队列表
        getTeamList(){
            xz.getConstrTeamLists(this.teamQuery).then(res => {
                // console.log('entPicFile', res)
                if (res.status == 'ok') {
                    this.teamList = res.msg
                } else {
                    this.teamList = []
                }
            })
        },
        // 返回
        backHandle(){
            this.$router.back()
            // this.$router.go(-1) // 后退+刷新
        },
        // 判断文件类型,图片预览，文件下载
        updataIf(e) {
            if (e.fileName) {
                let type1 = e.fileName.substring(e.fileName.length-4,e.fileName.length)
                if (type1.indexOf('png')>-1||type1.indexOf('PNG')>-1||type1.indexOf('JPG')>-1||type1.indexOf('JPEG')>-1||type1.indexOf('jpg')>-1||type1.indexOf('jpeg')>-1||type1 == 'webp') {
                    return false
                } else {
                    return true
                }
            } else {
                let type2 = e.name.substring(e.name.length-4,e.name.length)
                if (type2.indexOf('png')>-1||type2.indexOf('PNG')>-1||type2.indexOf('JPG')>-1||type2.indexOf('JPEG')>-1||type2.indexOf('jpg')>-1||type2.indexOf('jpeg')>-1||type2 == 'webp') {
                    return false
                } else {
                    return true
                }
            }
        },
        // 上传1寸照
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;
            // if (!isJPG) {
                // this.$message.error('上传头像图片只能是 JPG 格式!');
            // }
            if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isLt2M;
        },
        //判断是否为空
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
        }
    }
}
</script>

<style>
.page_update_tmember .e_form_box .el-form-item__label{
    padding: 0 6px 0 0;
}
.c_note_show .el-form-item__label:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
}
.page_update_tmember .el-upload-list--picture-card .el-upload-list__item-thumbnail{
    width: 100%;
    height: auto;
}
.page_update_tmember .file_img{
    width: 50px;
    height: auto;
}
.e_handle_content .el-form--inline .el-form-item__content{
    vertical-align: middle;
}
.e_handle_content .el-form-item__content{
    width: 305px;
}
.e_handle_content .e_half_line01 .el-form-item__content{
    width: 535px;
}
.e_handle_content .f_all_width01 .el-form-item__content{
    width: calc(100% - 135px);
}
.f_all_width .el-form-item__content{
    width: calc(100% - 135px);
}
.e_handle_content .el-form-item{
    margin-bottom: 16px;
    margin-right: 0;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }
  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }
  /* .e_handle_content .e_handle_box .c_form_box .el-input{
      flex: 1;
  } */
</style>
<style scoped>
.page_update_tmember{
    position: relative;
}
.page_update_tmember .main-con{
    padding: 0px 15px 80px;
}
.c_edit_txt{
    display: inline-block;
    width: 80px;
    white-space:nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.up_box{
    display: flex;
    width: 148px;
    height: 148px;
    justify-content: center;
    align-items: center;
}
.c_form_box{
    display: flex;
    box-sizing: border-box;
}
.r_edit_title .note_icon{
    color:#F56C6C;
    margin-left: 4px;
}
.f_upload_box{
    width: 100%;
}
.r_edit_title{
    width: 100%;
    font-size: 16px;
    line-height: 30px;
    margin-bottom: 10px;
    font-weight: bold;
    padding-left: 20px;
    border-bottom: 1px dashed #ddd;
    box-sizing: border-box;
    color: #333;
}
.u_txt{
    color:#999;
    font-weight: bold;
    font-size: 13px;
    margin-bottom: 10px;
}
.f_upload_list{
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-bottom: 16px;
    padding-left: 20px;
}
.f_upload_left{
    width: 130px;
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    /* line-height: 40px; */
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.face_line_box{
  display:flex;
  flex-wrap: wrap;
  font-size: 14px;
  margin-left: 10px;
}
.face_line_box .txts01{
  margin-right: 3px;
}
.face_line_box .txts02{
  margin-left: 3px;
}
.r_flex{
    display: flex;
    align-items: center;
}
.e_bottom_box{
    width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.e_bottom_box p{
    margin-right: 10px;
}
.e_handle_form{
    width: 100%;
    margin: 0 auto;
    flex-wrap: wrap;
}
.e_half_line{
    width: 549px;
}
.e_half_line01{
    width: 652px;
}
.e_handle_content .el-input,.e_handle_content .el-cascader,.e_handle_content .el-select{
    width: 300px;
}
.e_form_box{
    margin-top: 10px;
}
/* .e_btns_box{
    display: flex;
    justify-content: center;
    padding: 10px 0;
} */
.e_btns_content{
    width: 200px;
    margin-left: calc(50% - 200px);
}
.e_btns_box{
    width: 100%;
    display: flex;
    /* justify-content: center; */
    position: fixed;
    bottom: 0;
    background: #fff;
    z-index: 100;
    box-sizing: border-box;
    padding: 10px 0;
}
.f_all_width{
  width: 100%;
  align-items: center;
}
.e_line01{
    display: flex;
    align-items: center;
}
.e_handle_box .txt01{
    font-size: 13px;
    color:#19bd92;
    cursor: pointer;
    margin-left: 5px;
}
.e_handle_form{
    display: flex;
    /* text-align: center; */
}
.e_handle_box{
    width: 100%;
    padding: 10px 0;
    background-color: #fff;
    box-sizing: border-box;
}
.e_handle_box .el-form-item__label{
    padding: 0 5px 0 0;
}
.e_title{
    width: 100%;
    text-align: center;
    line-height: 25px;
    font-size: 16px;
    color: #333333;
}
</style>